import { helper } from '@ember/component/helper';

export function trueStringIfPresent([bool]: [boolean] /* , hash*/) {
  return bool ? 'true' : false;
}

export default helper(trueStringIfPresent);
